module.exports = __webpack_public_path__ + "img/7.36c9a2b8.png";